import { HasSubscriptions } from "../components/has-subscriptions";
import { Injectable } from "@angular/core";
import { Listing } from "../classes/listing";
import { SavedSearch } from "../classes/saved-search";
import { PreferencesService } from "./preferences.service";
import { CommunicationService } from "./communication.service";
import { TranslateService } from "@ngx-translate/core";
import { AnalyticsService } from "./analytics/analytics.service";
import {NOTIFICATION_CHECKBOX_VALUE, NOTIFICATION_ENABLED_OFFMARKET} from '../classes/analytics-tags';

@Injectable()

export class SaveSearchService extends HasSubscriptions {

  constructor(private _preferencesService: PreferencesService,
              private _communicationService: CommunicationService,
              private _translateService: TranslateService,
              private _analyticsService: AnalyticsService)
  {
    super();
  }

  public saveSearch(name: string, notification: boolean, listing?: Listing){
    if(listing == null){
      this.addSavedSearch(name, notification).then((s: SavedSearch) => {
        this.saveSearchedCompleted(s);
      });
    }
    else{
      this.addSavedSearchOffMarket(name, notification, listing).then((s: SavedSearch) => {
        this.saveSearchedCompleted(s, listing);
      });
    }
  }

  public addSavedSearch(name: string, notification: boolean, index: number = -1): Promise<SavedSearch> {
    return this._preferencesService.addNewSavedSearch(name, notification, index);
  }
  public addSavedSearchOffMarket(name: string, notification: boolean, listing: Listing, index: number = -1): Promise<SavedSearch> {
    return this._preferencesService.addNewSavedSearch(name, notification, index, listing);
  }

  private saveSearchedCompleted(s: SavedSearch, listing?: Listing) {
    this._communicationService.selectedSaveSearch.next(s);
    this._communicationService.notifications.bottomNotification.next(this._translateService.instant('actions.add-saved-search', { x: s.name }));
    this.emitTrackingEvents(s, listing);
  }

  private emitTrackingEvents(s: SavedSearch, listing?: Listing) {
    if(listing && listing.isOffMarket){
      this._analyticsService.eventTrack(NOTIFICATION_ENABLED_OFFMARKET, s.notificationsEnabled);
    }
    else {
      this._analyticsService.eventTrack(NOTIFICATION_CHECKBOX_VALUE, s.notificationsEnabled);
    }
  }
}

